import { HomeActionTypes, PostAction } from '../actions/post.action';
import { HomeState, initialHomeState } from '../states/home.state';
import { initialPostState, PostState } from '../states/post.state';
import { CommentState, initialCommentState } from '../states/comment.state';
import { initialReplyCommentState } from '../states/reply-comment.state';

export function HomeReducer(
  state = initialHomeState,
  action: PostAction
): HomeState {
  switch (action.type) {
    case HomeActionTypes.LoadTopFeed:
      return {
        ...state,
        feedError: '',
        feedLoadMoreError: '',
        feedLoading: true,
        postsState: []
      };

    case HomeActionTypes.SearchPosts:
      return {
        ...state,
        feedError: '',
        feedLoadMoreError: '',
        feedLoading: true,
        postsState: []
      };

    case HomeActionTypes.LoadUserPost:
      return {
        ...state,
        feedError: '',
        feedLoadMoreError: '',
        feedLoading: true,
        postsState: []
      };

    case HomeActionTypes.LoadUserFavorite:
      return {
        ...state,
        feedError: '',
        feedLoadMoreError: '',
        feedLoading: true,
        postsState: []
      };

    case HomeActionTypes.LoadExpandedPost:
      return {
        ...state,
        feedError: '',
        feedLoadMoreError: '',
        feedLoading: true,
        postsState: []
      };

    case HomeActionTypes.PostFormType:
      return {
        ...state,
        postFormState: {
          ...state.postFormState,
          formType: 'POST',
          showPoll: false,
          showTitle: false,
          showBody: true,
          showArticleBody: false,
          allowUpload: true
        }
      };
    case HomeActionTypes.PollFormType:
      return {
        ...state,
        postFormState: {
          ...state.postFormState,
          formType: 'POLL',
          showPoll: true,
          showTitle: false,
          showBody: false,
          showArticleBody: false,
          allowUpload: false,
          uploadFiles: []
        }
      };

    case HomeActionTypes.ArticleFormType:
      return {
        ...state,
        postFormState: {
          ...state.postFormState,
          formType: 'ARTICLE',
          showPoll: false,
          showTitle: true,
          showArticleBody: true,
          showBody: false,
          allowUpload: true
        }
      };

    case HomeActionTypes.UploadFile:
      return {
        ...state,
        postFormState: {
          ...state.postFormState,
          uploadFiles: state.postFormState.uploadFiles.map(uploadFileState => {
            if (uploadFileState.fileName !== action.payload.input.fileName) {
              return uploadFileState;
            }
            return {
              ...uploadFileState,
              loading: true
            };
          })
        }
      };

    // remove file in case of an error
    case HomeActionTypes.UploadFileError:
      return {
        ...state,
        postFormState: {
          ...state.postFormState,
          uploadFiles: state.postFormState.uploadFiles.filter(
            f => f.fileName !== action.payload
          )
        }
      };

    case HomeActionTypes.UploadFileSuccess:
      return {
        ...state,
        postFormState: {
          ...state.postFormState,
          uploadFiles: state.postFormState.uploadFiles.map(uploadFileState => {
            if (uploadFileState.fileName !== action.payload.fileName) {
              return uploadFileState;
            }
            return {
              ...uploadFileState,
              loading: false,
              uploaded: true,
              uploadUrl: action.payload.uploadUrl
            };
          })
        }
      };

    case HomeActionTypes.AddUploadFile:
      return {
        ...state,
        postFormState: {
          ...state.postFormState,
          uploadFiles: [action.payload].concat(state.postFormState.uploadFiles)
        }
      };

    case HomeActionTypes.RemoveUploadFile:
      return {
        ...state,
        postFormState: {
          ...state.postFormState,
          uploadFiles: state.postFormState.uploadFiles.filter(upF => {
            return (
              upF.path !== state.postFormState.uploadFiles[+action.payload].path
            );
          })
        }
      };

    case HomeActionTypes.AddVideoUploadFile:
      const videoItem = state?.postFormState?.uploadVideos?.filter(
        file => file.file.name === action.payload.file.name
      );

      let videosObj = [];
      if (videoItem.length === 0) {
        videosObj = state?.postFormState?.uploadVideos?.concat([
          action.payload
        ]);
      } else {
        videosObj = state?.postFormState?.uploadVideos.map(p => {
          if (p.file.name === action.payload.file.name) {
            return action.payload;
          }
          return p;
        });
      }

      return {
        ...state,
        postFormState: {
          ...state.postFormState,
          uploadVideos: videosObj
        }
      };

    case HomeActionTypes.RemoveVideoUploadFile:
      return {
        ...state,
        postFormState: {
          ...state.postFormState,
          uploadVideos: state.postFormState.uploadVideos.filter(
            p => p.file.name !== action.payload
          )
        }
      };

    case HomeActionTypes.LoadPostSuccess:
      const newPost =
        action.payload.posts
          ?.filter(post => post !== null)
          ?.map(post => {
            if (!post?.engagement) {
              return {
                ...initialPostState,
                deleted: true
              };
            }
            return {
              ...initialPostState,
              post: post
            };
          }) || [];

      return {
        ...state,
        postsState: newPost,
        postPagination: action?.payload?.pageInfo,
        feedLoading: false,
        feedError: ''
      };

    case HomeActionTypes.LoadExpandedPostSuccess:
      const commentsState =
        action.payload.comments.data
          ?.map(comment => {
            return {
              ...initialCommentState,
              comment: comment
            };
          })
          ?.reverse() || [];

      const singlePost = {
        ...initialPostState,
        post: action.payload,
        showComments: true,
        commentsState
      };

      return {
        ...state,
        postsState: [singlePost],
        postPagination: null,
        feedLoading: false,
        feedError: ''
      };

    case HomeActionTypes.LoadPostError:
      return {
        ...state,
        postsState: [],
        feedLoading: false,
        feedError: action.payload
      };

    case HomeActionTypes.ShowComments:
      return {
        ...state,
        postsState: state.postsState.map((postState: PostState) => {
          if (postState.post.Id === action.payload.postID) {
            return {
              ...postState,
              showComments: true,
              commentLoading: true
            };
          }
          return postState;
        })
      };

    case HomeActionTypes.HideComments:
      return {
        ...state,
        postsState: state.postsState.map((postState: PostState) => {
          if (postState.post.Id === action.payload) {
            return {
              ...postState,
              showComments: false,
              commentCursor: null,
              commentsState: []
            };
          }
          return postState;
        })
      };

    case HomeActionTypes.UpVotePost:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id === action.payload.postID) {
            return {
              ...postState,
              postVoteLoading: true,
              postVoteError: ''
            };
          }
          return postState;
        })
      };

    case HomeActionTypes.DownVotePost:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id === action.payload.postID) {
            return {
              ...postState,
              postVoteLoading: true,
              postVoteError: ''
            };
          }
          return postState;
        })
      };

    case HomeActionTypes.VotePostError:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id === action.payload.postId) {
            return {
              ...postState,
              postVoteLoading: false,
              postVoteError: action.payload.message
            };
          }
          return postState;
        })
      };

    case HomeActionTypes.VotePostSuccess:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id === action.payload.modifiedPost.Id) {
            return {
              ...postState,
              post: action.payload.modifiedPost,
              postVoteLoading: false,
              postVoteError: ''
            };
          }
          return postState;
        })
      };

    case HomeActionTypes.ShowCommentsSuccess:
      return {
        ...state,
        postsState: state.postsState.map((postState: PostState) => {
          if (postState.post.Id !== action.payload.Id) {
            return postState;
          }
          return {
            ...postState,
            commentLoading: false,
            commentsState:
              action.payload.comments.data
                ?.map(comment => {
                  return Object.assign(
                    {},
                    { ...initialCommentState },
                    { comment: comment }
                  );
                })
                ?.reverse() || [],
            commentCursor: action?.payload.comments?.pageInfo
          };
        })
      };

    case HomeActionTypes.ShowCommentsError:
      return {
        ...state,
        postsState: state.postsState.map((postState: PostState) => {
          if (postState.post.Id !== action.payload.postId) {
            return postState;
          }
          return {
            ...postState,
            commentLoading: false
          };
        })
      };

    case HomeActionTypes.CreateNormalPost:
      return {
        ...state,
        newPostState: {
          ...state.newPostState,
          newPostLoading: true,
          newPostError: '',
          newPost: null
        }
      };

    case HomeActionTypes.CreateNormalPostSuccess:
      console.error(action.payload);
      const newPostState: PostState = {
        ...initialPostState,
        post: action.payload
      };

      return {
        ...state,
        newPostState: {
          ...state.newPostState,
          newPost: action.payload,
          newPostLoading: false,
          newPostError: ''
        },
        postsState: [newPostState, ...state.postsState],
        postFormState: {
          ...state.postFormState,
          uploadFiles: []
        }
      };

    case HomeActionTypes.CreateNormalPostError:
      return {
        ...state,
        newPostState: {
          ...state.newPostState,
          newPostLoading: false,
          newPostError: action.payload,
          newPost: null
        }
      };

    // create echo
    case HomeActionTypes.CreateEchoPost:
      return {
        ...state,
        echoError: '',
        echoLoading: true
      };

    case HomeActionTypes.CreateEchoPostSuccess:
      const newEchoPost = {
        ...initialPostState,
        post: action.payload
      };

      return {
        ...state,
        echoError: '',
        echoLoading: false,
        postsState: [newEchoPost, ...state.postsState]
      };

    case HomeActionTypes.CreateEchoPostError:
      return {
        ...state,
        echoError: action.payload,
        echoLoading: false
      };

    case HomeActionTypes.CreateComment:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          return {
            ...postState,
            createCommentError: '',
            createCommentLoading: true
          };
        })
      };

    case HomeActionTypes.CreateCommentSuccess:
      const newComment: CommentState = {
        ...initialCommentState,
        comment: action.payload.comment
      };

      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id === action.payload.postId) {
            console.log('IDS are matching');
            return {
              ...postState,
              post: {
                ...postState.post,
                engagement: {
                  ...postState.post.engagement,
                  commentCount: postState.post.engagement.commentCount + 1
                }
              },
              createCommentError: '',
              createCommentLoading: false,
              commentsState: postState.commentsState.concat([newComment])
            };
          }
          return { ...postState };
        })
      };

    case HomeActionTypes.CreateCommentError:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          return {
            ...postState,
            createCommentError: action.payload,
            createCommentLoading: false
          };
        })
      };

    case HomeActionTypes.UpVoteComment:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.payload.postID) {
            return postState;
          }

          return {
            ...postState,
            commentsState: postState.commentsState.map(commentState => {
              if (commentState.comment.Id !== action.payload.commentID) {
                return commentState;
              }
              return {
                ...commentState,
                voteCommentError: '',
                voteCommentLoading: true
              };
            })
          };
        })
      };

    case HomeActionTypes.DownVoteComment:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.payload.postID) {
            return postState;
          }

          return {
            ...postState,
            commentsState: postState.commentsState.map(commentState => {
              if (commentState.comment.Id !== action.payload.commentID) {
                return commentState;
              }
              return {
                ...commentState,
                voteCommentError: '',
                voteCommentLoading: true
              };
            })
          };
        })
      };

    case HomeActionTypes.VoteCommentSuccess:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.payload.postID) {
            return postState;
          }

          return {
            ...postState,
            commentsState: postState.commentsState.map(commentState => {
              if (commentState.comment.Id !== action.payload.commentID) {
                return commentState;
              }
              return {
                ...commentState,
                voteCommentError: '',
                voteCommentLoading: false,
                comment: action.payload.payload
              };
            })
          };
        })
      };

    case HomeActionTypes.VoteCommentError:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.payload.postID) {
            return postState;
          }

          return {
            ...postState,
            commentsState: postState.commentsState.map(commentState => {
              if (commentState.comment.Id !== action.payload.commentID) {
                return commentState;
              }
              return {
                ...commentState,
                voteCommentError: action.payload.error,
                voteCommentLoading: false
              };
            })
          };
        })
      };

    case HomeActionTypes.LoadMoreComment:
      return {
        ...state,
        postsState: state.postsState.map((postState: PostState) => {
          if (postState.post.Id === action.payload.postID) {
            return {
              ...postState,
              showComments: true,
              commentLoading: true
            };
          }
          return postState;
        })
      };

    case HomeActionTypes.LoadMoreCommentSuccess:
      return {
        ...state,
        postsState: state.postsState.map((postState: PostState) => {
          if (postState.post.Id !== action.payload.Id) {
            return postState;
          }

          const newCommentsState =
            action.payload.comments.data?.map(comment => {
              return Object.assign(
                {},
                { ...initialCommentState },
                { comment: comment }
              );
            }) || [];

          return {
            ...postState,
            commentLoading: false,
            commentsState: newCommentsState
              ?.reverse()
              .concat([...postState.commentsState]),
            commentCursor: action?.payload.comments?.pageInfo
          };
        })
      };

    case HomeActionTypes.LoadMoreCommentError:
      return {
        ...state,
        postsState: state.postsState.map((postState: PostState) => {
          if (postState.post.Id !== action.payload.postId) {
            return postState;
          }
          return {
            ...postState,
            commentLoading: false
          };
        })
      };
    case HomeActionTypes.LoadUserProfileSuccess:
      return {
        ...state,
        socialUser: action.payload
      };

    case HomeActionTypes.DeletePost:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.payload.postID) {
            return postState;
          }
          return {
            ...postState,
            postLoading: true,
            postError: ''
          };
        })
      };

    case HomeActionTypes.DeletePostSuccess:
      const filtered = state.postsState.filter(
        postState => postState.post.Id !== action.payload.postId
      );
      return {
        ...state,
        postsState: [...filtered]
      };

    case HomeActionTypes.DeletePostError:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.payload.postId) {
            return postState;
          }
          return {
            ...postState,
            postLoading: false,
            postError: action.payload.message
          };
        })
      };

    case HomeActionTypes.DeleteComment:
      // will add data like loading if need be
      return {
        ...state
      };

    case HomeActionTypes.DeleteCommentSuccess:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id === action.payload.postId) {
            const okayComments = postState.commentsState.filter(
              commentState => {
                return commentState.comment.Id !== action.payload.commentId;
              }
            );

            return {
              ...postState,
              commentsState: okayComments,
              post: {
                ...postState.post,
                engagement: {
                  ...postState.post.engagement,
                  commentCount: postState.post.engagement.commentCount - 1
                }
              }
            };
          }
          return { ...postState };
        })
      };

    case HomeActionTypes.DeleteCommentError:
      // something can be done here later
      return { ...state };

    case HomeActionTypes.LoadMorePost:
      return {
        ...state,
        feedLoadMoreError: '',
        feedLoading: true
      };

    case HomeActionTypes.SearchMorePosts:
      return {
        ...state,
        feedLoadMoreError: '',
        feedLoading: true
      };

    case HomeActionTypes.LoadMoreUserPost:
      return {
        ...state,
        feedLoadMoreError: '',
        feedLoading: true
      };

    case HomeActionTypes.LoadMoreUserFavorite:
      return {
        ...state,
        feedLoadMoreError: '',
        feedLoading: true
      };

    case HomeActionTypes.LoadMorePostError:
      return {
        ...state,
        feedLoadMoreError: action.payload,
        feedLoading: false
      };

    case HomeActionTypes.LoadMorePostSuccess:
      const newPosts =
        action.payload.posts
          ?.filter(post => post !== null)
          ?.map(post => {
            if (!post?.engagement) {
              return {
                ...initialPostState,
                deleted: true
              };
            }
            return {
              ...initialPostState,
              post: post
            };
          }) || [];

      const fullArray = state.postsState.concat(newPosts);

      // const updatedPostState = fullArray
      //   .map(postState => postState?.post?.Id)
      //   .filter((value, index, self) => self.indexOf(value) === index)
      //   .map(postId => fullArray.find(el => el.post?.Id === postId));

      return {
        ...state,
        feedLoadMoreError: '',
        feedLoading: false,
        postsState: fullArray,

        postPagination: action.payload?.pageInfo
      };

    case HomeActionTypes.FavoritePost:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.payload.postID) {
            return postState;
          }

          return {
            ...postState,
            favoritePostLoading: true,
            favoritePostError: ''
          };
        })
      };

    case HomeActionTypes.UnFavoritePost:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.payload.postID) {
            return postState;
          }

          return {
            ...postState,
            favoritePostLoading: true,
            favoritePostError: ''
          };
        })
      };

    case HomeActionTypes.FavoritePostError:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.payload.postId) {
            return postState;
          }

          return {
            ...postState,
            favoritePostLoading: false,
            favoritePostError: action.payload.message
          };
        })
      };

    case HomeActionTypes.FavoritePostSuccess:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.payload.Id) {
            return postState;
          }

          return {
            ...postState,
            post: action.payload,
            favoritePostLoading: false,
            favoritePostError: ''
          };
        })
      };

    case HomeActionTypes.VotePostPoll:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.payload.postID) {
            return postState;
          }
          return {
            ...postState,
            pollPostLoading: true,
            pollPostError: ''
          };
        })
      };

    case HomeActionTypes.VotePostPollSuccess:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.payload.Id) {
            return postState;
          }
          return {
            ...postState,
            post: action.payload,
            pollPostLoading: false,
            pollPostError: ''
          };
        })
      };

    case HomeActionTypes.VotePostPollError:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.payload.postId) {
            return postState;
          }
          return {
            ...postState,
            pollPostLoading: false,
            pollPostError: action.payload.message
          };
        })
      };

    // reply actions
    case HomeActionTypes.ShowReplyComment:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.payload.postID) {
            return postState;
          }
          return {
            ...postState,
            commentsState: postState.commentsState.map(commentState => {
              if (commentState.comment.Id !== action.payload.commentID)
                return commentState;

              return {
                ...commentState,
                replyMessages: [],
                replyLoading: true,
                replyError: '',
                replyPageInfo: null,
                showCommentReply: true
              };
            })
          };
        })
      };

    case HomeActionTypes.HideReplyComment:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.payload.postID) {
            return postState;
          }
          return {
            ...postState,
            commentsState: postState.commentsState.map(commentState => {
              if (commentState.comment.Id !== action.payload.commentID)
                return commentState;

              return {
                ...commentState,
                replyMessages: [],
                replyLoading: true,
                replyError: '',
                replyPageInfo: null,
                showCommentReply: false
              };
            })
          };
        })
      };

    case HomeActionTypes.ShowReplyCommentSuccess:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.payload.postID) {
            return postState;
          }
          const replyCommentState =
            action?.payload?.output?.data
              ?.map(reply => {
                return {
                  ...initialReplyCommentState,
                  comment: reply
                };
              })
              ?.reverse() || [];

          return {
            ...postState,
            commentsState: postState.commentsState.map(commentState => {
              if (commentState.comment.Id !== action.payload.commentID)
                return commentState;

              return {
                ...commentState,
                replyLoading: false,
                replyMessages: replyCommentState,
                replyPageInfo: action?.payload?.output?.pageInfo
              };
            })
          };
        })
      };

    case HomeActionTypes.ShowReplyCommentError:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.payload.postID) {
            return postState;
          }

          return {
            ...postState,
            commentsState: postState.commentsState.map(commentState => {
              if (commentState.comment.Id !== action.payload.commentID)
                return commentState;

              return {
                ...commentState,
                replyLoading: false,
                replyError: action.payload.error
              };
            })
          };
        })
      };

    // create reply
    case HomeActionTypes.CreateReplyComment:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.input.postID) {
            return postState;
          }
          return {
            ...postState,
            commentsState: postState.commentsState.map(commentState => {
              if (commentState.comment.Id !== action.input.commentID)
                return commentState;

              return {
                ...commentState,
                replyLoading: true,
                replyError: ''
              };
            })
          };
        })
      };

    case HomeActionTypes.CreateReplyCommentSuccess:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.input.postID) {
            return postState;
          }
          return {
            ...postState,
            commentsState: postState.commentsState.map(commentState => {
              if (commentState.comment.Id !== action.input.commentID)
                return commentState;

              const singleCommentState = {
                ...initialReplyCommentState,
                comment: action.input.payload
              };

              return {
                ...commentState,
                comment: {
                  ...commentState.comment,
                  replyCount: commentState.comment.replyCount + 1
                },
                replyLoading: false,
                replyMessages: commentState.replyMessages?.concat([
                  singleCommentState
                ])
              };
            })
          };
        })
      };
    case HomeActionTypes.LoadMoreReplyComment:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.payload.postID) {
            return postState;
          }
          return {
            ...postState,
            commentsState: postState.commentsState.map(commentState => {
              if (commentState.comment.Id !== action.payload.commentID)
                return commentState;

              return {
                ...commentState,
                replyLoading: true,
                replyError: ''
              };
            })
          };
        })
      };

    case HomeActionTypes.LoadMoreReplyCommentSuccess:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.payload.postID) {
            return postState;
          }
          const replyMoreCommentState =
            action?.payload?.output?.data
              ?.map(reply => {
                return {
                  ...initialReplyCommentState,
                  comment: reply
                };
              })
              ?.reverse() || [];

          return {
            ...postState,
            commentsState: postState.commentsState.map(commentState => {
              if (commentState.comment.Id !== action.payload.commentID)
                return commentState;

              return {
                ...commentState,
                replyLoading: false,
                replyMessages: replyMoreCommentState?.concat(
                  commentState?.replyMessages
                ),
                replyPageInfo: action?.payload?.output?.pageInfo
              };
            })
          };
        })
      };

    case HomeActionTypes.VoteReplyCommentSuccess:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.payload.postID) {
            return postState;
          }
          return {
            ...postState,
            commentsState: postState?.commentsState?.map(cs => {
              if (cs.comment?.Id !== action?.payload?.commentID) {
                return cs;
              }
              const updateReplyState = cs.replyMessages.map(rms => {
                if (rms?.comment?.Id !== action?.payload?.replyCommentID) {
                  return rms;
                }
                return {
                  comment: {
                    ...action?.payload?.output
                  }
                };
              });
              return {
                ...cs,
                replyMessages: [...updateReplyState]
              };
            })
          };
        })
      };

    case HomeActionTypes.DeleteReplyCommentSuccess:
      return {
        ...state,
        postsState: state.postsState.map(postState => {
          if (postState.post.Id !== action.payload.postID) {
            return postState;
          }
          return {
            ...postState,
            commentsState: postState?.commentsState?.map(cs => {
              if (cs.comment?.Id !== action?.payload?.commentID) {
                return cs;
              }
              const removeComment =
                cs?.replyMessages?.filter(
                  rms => rms?.comment?.Id !== action?.payload?.replyCommentID
                ) || [];
              return {
                ...cs,
                replyMessages: [...removeComment]
              };
            })
          };
        })
      };

    default:
      return state;
  }
}
